export const DEFAULT_EXCLUDED_STATUSES = ['AR'];

// Build the /call_todo query params for a PDF or CSV export from the user's saved settings.
// settings: { excludedStatuses?: string[], hideFutureCalls?: boolean } | null
export const buildExportQuery = ({ deskId, settings }) => {
  const excluded = settings?.excludedStatuses ?? DEFAULT_EXCLUDED_STATUSES;

  const params = [
    { $populate: 'recipientId' },
    { $populate: 'companyId' },
    { $populate: 'deskId' },
    { '$sort[occurrence_date]': '-1' },
    { $excludes: 'personId.profile_pic' },
    { $limit: '500' },
    { timezone: new Date().getTimezoneOffset() },
    { deskId },
  ];

  // Exclude the hidden status groups (defaults to Archive). Exclude rather than include
  // means any status not explicitly hidden is exported, so Archive stays excluded even
  // when deskStatuses is empty/unknown, and newly added desk statuses export by default.
  // Sent as the benign `excludeStatuses` param (server builds the Mongo filter): raw
  // operators like status[$ne]/status[$nin] belong server-side, and Cloudflare's WAF
  // rightly flags them as NoSQL injection.
  excluded.filter(Boolean).forEach((code) => params.push({ excludeStatuses: code }));

  // Always explicit. The report endpoint otherwise falls back to the desk-wide
  // `settings.hideFutureCalls`, which would drop future calls even when this dialog says to
  // keep them. Sending the flag both ways makes the per-export choice authoritative.
  params.push({ hideFutureCalls: settings?.hideFutureCalls ? 'true' : 'false' });

  return params;
};
